/*!
 * PropPerks storefront — progress bar, cart gift block, checkout guard
 * Ported from the incumbent Milestones app block by scripts/port-frontend.py (do not hand-edit
 * the ported sections without updating the script). Config comes from window.PropPerks,
 * set in snippets/propperks.liquid.
 */
(function() {
    function esc(str) { var d = document.createElement('div'); d.textContent = str; return d.innerHTML; }

    var PP = window.PropPerks || {};
    var PP_PROXY = PP.proxy || '/apps/propperks';
    var customerId = PP.customerId || null;
    // Marketplace product ids (Change 1) — their lines count £0 toward the tiers.
    var marketplaceIds = {};
    function setMarketplace(ids) { marketplaceIds = {}; (ids || []).forEach(function(id) { marketplaceIds[id] = 1; }); window.__pp_marketplaceIds = marketplaceIds; }
    function isGiftCode(code) { var c = (code || '').toUpperCase(); return c.indexOf('PP-') === 0 || c.indexOf('GIFT-') === 0; }
    // Region is resolved server-side from the real cart, so pass its token + market context.
    function tiersUrl(cart) {
      var u = PP_PROXY + '?action=tiers&currency=' + encodeURIComponent(currencyCode);
      if (cart && cart.token) u += '&cart=' + encodeURIComponent(cart.token);
      if (PP.country) u += '&country=' + encodeURIComponent(PP.country);
      return u;
    }
    // Claim-in-flight marker, written by the gift chooser. It lives in localStorage so every tab
    // sees it (a per-tab flag let a second tab strip the gift mid-claim), plus this tab's own
    // copies (sessionStorage, and window.__pp_claimInFlight for this page) that another tab's
    // claim can never overwrite or clear. Value: "<timestamp>:<attempt>".
    function claimInFlightTs() {
      var ts = parseInt(window.__pp_claimInFlight || '0', 10) || 0;
      ['localStorage', 'sessionStorage'].forEach(function(kind) {
        try { ts = Math.max(ts, parseInt(window[kind].getItem('pp_claim_inflight') || '0', 10) || 0); } catch (e) {}
      });
      return ts;
    }
    function claimInFlight() { var ts = claimInFlightTs(); return ts > 0 && (Date.now() - ts) < 30000; }
    // One shared grace re-check for every bar instance (page + drawer). Each instance used to
    // schedule its own, and each re-check re-rendered both, so reloads doubled every 2 s.
    var graceRetryTimer = null;
    function scheduleGraceRetry() {
      if (graceRetryTimer) return;
      graceRetryTimer = setTimeout(function() { graceRetryTimer = null; updateFromCart(); }, 2000);
    }
    var autoRemoveInFlight = false;
    // Server-authoritative unlock. When the tiers payload carries a verdict the server has priced
    // the real basket in GBP, so it alone decides which tiers are unlocked: every active tier at
    // or below unlockedTierId, exactly as the claim check does. Converted thresholds are then
    // display only. A verdict counts only when the server judged the basket: judged:true, or (a
    // Worker that predates `judged`) a numeric ownSubtotalGbp. When it skipped the basket (rate
    // limit, too many lines, cart read failed) it sends judged:false / null fields, and that is
    // NO verdict, not "nothing unlocked" (pass-3 P3-2): the estimate then applies for display,
    // and the gift is never auto-removed on it. Only a judged verdict for THIS basket saying the
    // gift's tier is no longer reached removes a gift. An older Worker sends no verdict field at
    // all: the converted-threshold estimate applies for display, and nothing is auto-removed.
    // A Worker that gives verdicts says so with `judged` on every answer, and its unjudged answer
    // is just {judged:false} with no unlockedTierId (pass-4 P4-10): that still means the server
    // decides, so later quantity changes keep asking for a verdict. A Worker that predates
    // `judged` shows it by sending unlockedTierId.
    var serverDecides = false; // the Worker sends verdicts, so the tiers refresh follows quantities
    var serverUnlock = null; // { ids, ownGbp, key } — the last judged verdict, for the basket whose cartQtyKey is `key`
    function verdictKnown(data) {
      return !!data && (data.judged === true || data.judged === undefined) && typeof data.ownSubtotalGbp === 'number';
    }
    function withoutVerdict(data) {
      var out = {};
      Object.keys(data).forEach(function(k) { out[k] = data[k]; });
      out.judged = false; // no verdict (the fields stay, as in any unjudged answer)
      out._ppUnverified = true;
      return out;
    }
    function givesVerdicts(data) {
      return Object.prototype.hasOwnProperty.call(data, 'judged') || Object.prototype.hasOwnProperty.call(data, 'unlockedTierId');
    }
    function applyServerUnlock(data, key) {
      if (!data || !data.tiers || !givesVerdicts(data)) { serverDecides = false; serverUnlock = null; return; }
      serverDecides = true;
      if (!verdictKnown(data)) { serverUnlock = null; return; }
      var top = null;
      data.tiers.forEach(function(t) { if (t.id === data.unlockedTierId) top = t; });
      var ids = {};
      if (top) data.tiers.forEach(function(t) { if (t.threshold <= top.threshold) ids[t.id] = 1; });
      serverUnlock = { ids: ids, ownGbp: data.ownSubtotalGbp, key: key || '' };
    }
    function serverVerdictFresh() { return !!serverUnlock && serverUnlock.key === (window.__pp_currentCartKey || ''); }
    function isTierUnlocked(t, cartTotal) { return serverUnlock ? !!serverUnlock.ids[t.id] : cartTotal >= convertThreshold(t.threshold); }
    // Amount still to spend for `tier`, as the string the incumbent formatted.
    function remainingToUnlock(tier, cartTotal) {
      if (!serverUnlock) return (convertThreshold(tier.threshold) - cartTotal).toFixed(2);
      var r = serverVerdictFresh()
        ? (tier.threshold - serverUnlock.ownGbp) * currencyRate
        : convertThreshold(tier.threshold) - cartTotal;
      return String(Math.max(1, Math.ceil(r - 1e-9)));
    }
    // Quantities matter to the server's verdict (not just which variants), so the tiers refresh
    // is keyed on them too once the server decides.
    function cartQtyKey(cart) {
      return ((cart && cart.items) || []).map(function(item) {
        return item.variant_id + 'x' + item.quantity + (item.properties && item.properties['Free Gift'] ? 'g' : '');
      }).sort().join(',');
    }
    function refreshKeyFor(skuKey, qtyKey) { return serverDecides ? skuKey + '#' + qtyKey : skuKey; }
    function currentRefreshKey() { return refreshKeyFor(window.__pp_currentBasketSkus || '', window.__pp_currentCartKey || ''); }
    // Tiers payloads, shared by the bar and the chooser and kept per cart token + quantities
    // (pass-3 P3-2). Every cart-reading lookup counts against the Worker's hourly limits (60 a
    // basket, 300 an IP address), so an unchanged basket is not read again: a request in flight
    // is shared (the chooser makes no lookup of its own on page load), a payload is reused on
    // this page for TIERS_TTL, and a JUDGED payload is also kept in sessionStorage for TIERS_TTL,
    // so browsing without changing the basket costs nothing. Failures are never kept. An
    // unjudged payload is kept on this page only, so the next page view asks again.
    // A verdict is filed only under the basket it judged (pass-4 P4-24). The Worker reads the
    // cart when the request reaches it, which can be after the basket read this lookup was made
    // for (another tab, or a change the page hasn't read yet). So a judged answer is checked by
    // reading the basket once more: the same quantities before the request and after the answer
    // mean the verdict is this basket's. Otherwise (or if that read fails) nobody knows which
    // basket it judged: it is neither kept nor used as a verdict (the tiers and gifts still
    // apply, as an unjudged answer, marked _ppUnverified so the bar asks again).
    var TIERS_TTL = 5 * 60 * 1000;
    var UNVERIFIED_RETRIES = 2;
    var unverifiedRetries = 0;
    var TIERS_STORE = 'pp_tiers_cache';
    var TIERS_STORE_MAX = 4;
    var tiersMemo = {};
    function tiersKey(cart) { return tiersUrl(cart) + '|' + (customerId || '') + '|' + cartQtyKey(cart); }
    function tiersFresh(at) { var age = Date.now() - at; return age >= 0 && age < TIERS_TTL; }
    function readTiersStore() {
      try {
        var s = JSON.parse(sessionStorage.getItem(TIERS_STORE) || '{}');
        return s && typeof s === 'object' ? s : {};
      } catch (e) { return {}; }
    }
    function storeTiers(key, at, data) {
      try {
        var s = readTiersStore();
        s[key] = { at: at, data: data };
        Object.keys(s).sort(function(a, b) { return s[b].at - s[a].at; }).forEach(function(k, i) {
          if (i >= TIERS_STORE_MAX || !tiersFresh(s[k].at)) delete s[k];
        });
        sessionStorage.setItem(TIERS_STORE, JSON.stringify(s));
      } catch (e) {}
    }
    function loadTiers(cart) {
      resolveCurrency(cart);
      var key = tiersKey(cart);
      var memo = tiersMemo[key];
      if (memo && tiersFresh(memo.at)) return memo.p;
      var stored = readTiersStore()[key];
      if (stored && tiersFresh(stored.at) && verdictKnown(stored.data)) {
        tiersMemo[key] = { at: stored.at, p: Promise.resolve(stored.data) };
        return tiersMemo[key].p;
      }
      var at = Date.now();
      var qtyKey = cartQtyKey(cart);
      var p = fetch(tiersUrl(cart))
        .then(function(r) {
          if (!r.ok) throw new Error('tiers HTTP ' + r.status);
          return r.json();
        })
        .then(function(data) {
          if (!verdictKnown(data)) return data;
          return fetch('/cart.js')
            .then(function(r) {
              if (!r.ok) throw new Error('cart HTTP ' + r.status);
              return r.json();
            })
            .then(function(now) { return cartQtyKey(now) === qtyKey; }, function() { return false; })
            .then(function(sameBasket) {
              if (sameBasket) { storeTiers(key, at, data); return data; }
              delete tiersMemo[key];
              return withoutVerdict(data);
            });
        }, function(err) {
          delete tiersMemo[key];
          throw err;
        });
      tiersMemo[key] = { at: at, p: p };
      return p;
    }
    window.__pp_loadTiers = loadTiers;
    // An approved claim changes what the server judges for this customer: start afresh.
    window.__pp_forgetTiers = function() {
      tiersMemo = {};
      try { sessionStorage.removeItem(TIERS_STORE); } catch (e) {}
    };
    // Leftover gift lines (pass-3 P3-16 follow-on). An approved claim can leave the old gift
    // line behind (removing it failed twice). Its code was deleted with the claim, but the new
    // code applies to the new line, so hasGiftDiscount is true and the checkout guard would let
    // the old line through at full price. /cart.js lists the discounts allocated to each line:
    // a gift line is covered when an applicable gift code is allocated to it. Once one gift line
    // is covered, every uncovered gift line is a leftover and is taken out. A covered line is
    // never removed, nor is a line without the 'Free Gift' property, and nothing is removed
    // while no gift line is covered (the missing-discount guard deals with that). While a claim
    // is in flight (in any tab) the NEW line is the uncovered one until its code is applied, so
    // only lines this tab's own claim recorded as old may go (the chooser records them, for
    // OLD_GIFT_LINES_TTL, when it couldn't remove them).
    var OLD_GIFT_LINES = 'pp_old_gift_lines';
    var OLD_GIFT_LINES_TTL = 5 * 60 * 1000;
    var strayGiftKeys = []; // leftover gift lines in the last basket read, for the checkout guard
    // Set once this page has taken a gift line out, or sent a removal whose answer never came (it
    // may have been made): the bar's (tier lost, no working code, leftovers) or the checkout
    // guard's (sendRemoval sets it). The theme's basket form was rendered with that line still in
    // it, and its quantity boxes (updates[]) are matched to the basket's lines by position. With a
    // line gone the form has one box too many; once a gift line's paid units are put back as a
    // line of their own (P5-12) the count matches again, and posting the form would set the wrong
    // quantities: a former free unit charged, or an extra unit of another line (pass-6 P6-1). The
    // checkout guard then goes straight to checkout instead of letting the form post.
    var formStale = false;
    // The bar's tier-lost removals (pass-6 P6-2): under way, and whether one was made. Such a
    // removal ends by clearing the discount on the way back to the basket, since the gift line's
    // paid units, put back as an ordinary line of the gift's variant (P5-12), would be free under
    // the gift code still on the basket (a fixed amount on that variant). A checkout pressed
    // meanwhile may read a basket with the gift already gone, and must not go to checkout ahead
    // of that redirect with the code still on: while one is under way or once one was made, every
    // way the checkout guard sends the customer on clears the discount too.
    var tierLostRemovals = 0;
    var tierLostRemoved = false;
    function tierLostLeaving() { return tierLostRemoved || tierLostRemovals > 0; }
    var guardBypass = false; // set while the checkout guard re-triggers the customer's own checkout
    function recordedOldGiftLines() {
      try {
        var r = JSON.parse(sessionStorage.getItem(OLD_GIFT_LINES) || 'null');
        var age = r ? Date.now() - r.at : -1;
        return r && Array.isArray(r.keys) && age >= 0 && age < OLD_GIFT_LINES_TTL ? r.keys : [];
      } catch (e) { return []; }
    }
    function giftCodeCovers(item, liveCodes) {
      return (item.line_level_discount_allocations || []).some(function(a) {
        var app = a.discount_application || {};
        return a.amount > 0 && (liveCodes[String(app.title || '').toUpperCase()] === 1 || liveCodes[String(app.key || '').toUpperCase()] === 1);
      });
    }
    function giftCover(cart) {
      var live = {}, covered = 0, uncovered = [];
      (cart.discount_codes || []).forEach(function(dc) {
        if (dc.applicable === true && isGiftCode(dc.code)) live[String(dc.code).toUpperCase()] = 1;
      });
      (cart.items || []).forEach(function(item) {
        if (!(item.properties && item.properties['Free Gift'])) return;
        if (giftCodeCovers(item, live)) covered++;
        else uncovered.push(item.key);
      });
      return { live: live, covered: covered, uncovered: uncovered };
    }
    function strayGiftLines(cart) {
      var c = giftCover(cart);
      if (!c.covered) return [];
      if (!claimInFlight()) return c.uncovered;
      var old = recordedOldGiftLines();
      return c.uncovered.filter(function(k) { return old.indexOf(k) !== -1; });
    }
    // Paid units on a gift line (pass-5 P5-12). The theme's quantity box is editable on every
    // line, so a gift line can hold paid units too: one free unit and the rest bought (the bar
    // counts every unit after the first toward the tiers). A line's gift properties can't be
    // taken off it, so taking the gift out removes the whole line; the paid units are then put
    // back as an ordinary line of the same variant, with no gift properties, and only the free
    // unit goes. Every removal of a gift line does this: the checkout guard's, the bar's (tier
    // lost, no working code, leftovers) and the gift chooser's swap. One attempt, never
    // repeated: an add whose answer was lost may still have been made, and a second would
    // charge for the units twice. If it fails, the gift stays out (it must never stay free).
    function restorePaidUnits(lines) {
      var items = [];
      lines.forEach(function(item) {
        if (item.quantity > 1) items.push({ id: item.variant_id, quantity: item.quantity - 1 });
      });
      if (!items.length) return Promise.resolve();
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function() {}, function() {});
    }
    // One gift-line removal at a time on this page (pass-5 P5-12, checker). Putting paid units
    // back can't be repeated safely, so two removals of the same line must never both do it: the
    // bar's and the checkout guard's (Checkout pressed just after a basket change), say. Shopify
    // answers an update naming a line that has already gone as a success, so each would put the
    // units back and the customer would pay for them twice. Removals therefore queue here, and
    // each works from a basket read made once every earlier removal had been answered: its
    // caller's read when no removal has been sent, or was waiting or under way, since that read
    // was asked for; otherwise a fresh read (the caller's, should that fail). Lines already gone
    // are left alone and nothing is put back for them. A removal that never answers holds the
    // queue for REMOVAL_QUEUE_WAIT at most; the next one then reads the basket afresh, and puts
    // back nothing for a line the removal still under way is taking out (sendRemoval): if both
    // are applied, the one still under way puts the units back; if only the later one is, they
    // are lost, never charged twice.
    var REMOVAL_QUEUE_WAIT = 4000;
    var removalQueue = Promise.resolve();
    var removalsPending = 0; // waiting or under way
    var removalSeq = 0; // one more as each removal is sent
    function markRead() { return removalsPending ? -1 : removalSeq; }
    function readCart() {
      var mark = markRead();
      return fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart && typeof cart === 'object') {
            try { Object.defineProperty(cart, '_ppRead', { value: mark, configurable: true }); } catch (e) {}
          }
          return cart;
        });
    }
    function serialRemoval(cart, fn) {
      removalsPending++;
      var turn = new Promise(function(resolve) {
        var timer = setTimeout(resolve, REMOVAL_QUEUE_WAIT);
        removalQueue.then(function() { clearTimeout(timer); resolve(); });
      });
      var run = turn.then(function() {
        // The caller's read is current if no removal was waiting or under way when it was asked
        // for, and none has been sent since (then nothing sent is missing from it).
        if (cart && cart._ppRead === removalSeq) return cart;
        return fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(c) { return c && c.items ? c : cart; }, function() { return cart; });
      }).then(fn);
      var finish = function() { removalsPending--; };
      var settled = run.then(function(v) { finish(); return v; }, function(err) { finish(); throw err; });
      removalQueue = settled.then(function() {}, function() {});
      return settled;
    }
    function linesWithKeys(cart, keys) {
      return ((cart && cart.items) || []).filter(function(item) { return keys.indexOf(item.key) !== -1; });
    }
    // Sends one removal of these lines (request() makes the call). onAnswer(answer) runs first
    // and says whether the removal was made (it may throw); if it was, the paid units of the
    // lines no other removal under way is taking out are put back. Resolves with onAnswer's say.
    // A removal made, or one with no answer (it may have been made), leaves the page's basket
    // form stale (formStale); one refused (an error answer) doesn't.
    var removingKeys = {}; // line key → removals under way that take it out
    function sendRemoval(lines, request, onAnswer) {
      var mine = lines.filter(function(item) { return !removingKeys[item.key]; });
      lines.forEach(function(item) { removingKeys[item.key] = (removingKeys[item.key] || 0) + 1; });
      var release = function() { lines.forEach(function(item) { if (!--removingKeys[item.key]) delete removingKeys[item.key]; }); };
      removalSeq++;
      return request()
        .then(function(r) {
          if (!onAnswer(r)) return false;
          formStale = true;
          return restorePaidUnits(mine).then(function() { return true; });
        }, function(err) {
          formStale = true;
          throw err;
        })
        .then(function(made) { release(); return made; }, function(err) { release(); throw err; });
    }
    // Takes out the gift lines with these keys (those still in the basket); cart is the basket
    // read they came from.
    function removeGiftLines(keys, cart) {
      return serialRemoval(cart, function(c) {
        var lines = linesWithKeys(c, keys);
        if (!lines.length) return; // already gone: nothing to take out or put back
        var updates = {};
        lines.forEach(function(item) { updates[item.key] = 0; });
        return sendRemoval(lines, function() {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        }, function(r) {
          if (!r.ok) throw new Error('cart update HTTP ' + r.status);
          try { sessionStorage.removeItem(OLD_GIFT_LINES); } catch (e) {}
          return true;
        });
      });
    }
    // Automatic removals are bounded (pass-4 P4-11). The page's fetch hook re-reads the basket
    // after every /cart/update.js or /cart/change.js answer, errors included, so a basket error
    // that lasts (HTTP 429, say) used to re-send the same removal about every second for as long
    // as the page was open. Now each set of lines gets REMOVAL_ATTEMPTS tries on this page, the
    // next one REMOVAL_BACKOFF after a failure; then the bar leaves it to the checkout guard
    // (which tries once more, on a fresh read, whenever checkout is pressed) and to the server's
    // after-the-fact check.
    var REMOVAL_ATTEMPTS = 2;
    var REMOVAL_BACKOFF = 2000;
    var removalFailures = {}; // sorted line keys → { n, at }
    function removalKey(keys) { return keys.slice().sort().join('|'); }
    function removalAllowed(keys) {
      var f = removalFailures[removalKey(keys)];
      return !f || (f.n < REMOVAL_ATTEMPTS && Date.now() - f.at >= REMOVAL_BACKOFF);
    }
    function removalFailed(keys) {
      var k = removalKey(keys);
      var n = (removalFailures[k] ? removalFailures[k].n : 0) + 1;
      removalFailures[k] = { n: n, at: Date.now() };
      if (n < REMOVAL_ATTEMPTS) setTimeout(function() { lastCartTotal = null; updateFromCart(); }, REMOVAL_BACKOFF);
    }
    // A gift line in the basket with no gift code applied: its gift is no longer free (the code
    // was superseded, blocked, spent or displaced). Grace first: a claim in flight in any tab, or
    // the first 8 s after /discount/<code> while Shopify catches up. Then one removal at a time
    // across every bar instance, the marker re-checked just before sending in case a claim
    // started meanwhile.
    function giftGrace() {
      var redirectTs = 0;
      try { redirectTs = parseInt(sessionStorage.getItem('pp_discount_redirect') || '0', 10) || 0; } catch (e) {}
      return claimInFlight() || (redirectTs > 0 && (Date.now() - redirectTs) < 8000);
    }
    function removeCodelessGift() {
      if (autoRemoveInFlight) return;
      autoRemoveInFlight = true;
      var releaseAutoRemove = function() { autoRemoveInFlight = false; };
      // (Its own basket read, made in the removal queue: serialRemoval with no read of ours.)
      serialRemoval(null, function(cart) {
          var giftItem = ((cart && cart.items) || []).find(function(item) {
            return item.properties && item.properties['Free Gift'];
          });
          if (!giftItem || claimInFlight() || !removalAllowed([giftItem.key])) { releaseAutoRemove(); return; }
          return sendRemoval([giftItem], function() {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: giftItem.key, quantity: 0 })
            });
          }, function(r) {
            releaseAutoRemove();
            if (!r.ok) { removalFailed([giftItem.key]); return false; }
            hasGiftInCart = false;
            hasGiftDiscount = false;
            currentGiftTierName = null;
            try { sessionStorage.removeItem('pp_discount_code'); } catch (e) {}
            document.body.classList.remove('pp-has-gift');
            lastCartTotal = null;
            return true;
          }).catch(function() {
            releaseAutoRemove();
            removalFailed([giftItem.key]);
          });
        }).then(function(removed) { if (removed) updateFromCart(); }, releaseAutoRemove);
    }
    // Basket safety for everyone the bar doesn't run for (pass-4 P4-12). A D17 block or a spent
    // slot deletes the code of a gift already in the basket, and the customer then reads as not
    // eligible (or as a Prop Pro, or lapsed), so the bar never read the basket and the checkout
    // guard saw no gift. Now the basket is still read, on load and after every basket change, for
    // any logged-in customer the programme answered for (not when it is switched off), and for
    // anyone whose tiers lookup failed: leftovers and gift lines without a working code are taken
    // out (evaluateCart, as for everyone), and the checkout guard knows about gift lines. The
    // watch makes no tiers lookup and draws nothing (a Prop Pro or lapsed message still updates).
    var basketWatch = false;
    function startBasketWatch() {
      basketWatch = true;
      updateFromCart();
    }
    // Checkout after a re-applied code (pass-4 P4-9). The code stored for the checkout guard may
    // have been deleted since (a superseded claim, a D17 block, a spent slot), and Shopify still
    // lists a deleted code on the basket (applicable:false), exactly as it lists a live one that
    // another discount has pushed out. So the guard never sends a re-applied code straight to
    // checkout: it goes back to the basket (/discount/clear → /discount/<code> → /cart), and the
    // bar there carries on to checkout only once the fresh basket shows every gift line discounted.
    // Otherwise the usual missing-discount handling takes over (grace, then removal) and the
    // customer sees why. One re-apply per code in REAPPLY_BLOCK; the next checkout removes the gift.
    var REAPPLY = 'pp_checkout_reapply';
    var REAPPLY_RESUME = 60 * 1000;
    var REAPPLY_BLOCK = 10 * 60 * 1000;
    function readReapply() {
      try {
        var r = JSON.parse(sessionStorage.getItem(REAPPLY) || 'null');
        var age = r ? Date.now() - r.at : -1;
        return age >= 0 ? { code: r.code, resume: r.resume, age: age } : null;
      } catch (e) { return null; }
    }
    function startReapply(code) {
      var r = readReapply();
      if (r && r.code === code && r.age < REAPPLY_BLOCK) return false;
      try {
        sessionStorage.setItem(REAPPLY, JSON.stringify({ code: code, at: Date.now(), resume: true }));
        sessionStorage.setItem('pp_discount_redirect', String(Date.now()));
      } catch (e) { return false; }
      return true;
    }
    function endResume() {
      try {
        var r = JSON.parse(sessionStorage.getItem(REAPPLY) || 'null');
        r.resume = false;
        sessionStorage.setItem(REAPPLY, JSON.stringify(r));
      } catch (e) {}
    }
    function resumePending() {
      var r = readReapply();
      return !!r && r.resume && r.age < REAPPLY_RESUME && window.location.pathname.indexOf('/cart') !== -1;
    }
    function storedGiftCode() {
      try { return sessionStorage.getItem('pp_discount_code'); } catch (e) { return null; }
    }
    // Gift lines whose tier the server's verdict for this very basket (same quantities) says is
    // no longer reached: the bar's tier-lost rule, for the checkout guard. The bar's own removal
    // is bounded (P4-11), so when it was refused the guard takes these out (and, if that fails
    // too, clears the discount), rather than let the gift through free below its tier.
    function tierLostGiftLines(cart) {
      if (!cachedTiers || !serverUnlock || serverUnlock.key !== cartQtyKey(cart) || claimInFlight()) return [];
      var lost = [];
      (cart.items || []).forEach(function(item) {
        var name = item.properties && item.properties['Free Gift'];
        if (!name) return;
        var tier = cachedTiers[0];
        for (var i = 0; i < cachedTiers.length; i++) { if (cachedTiers[i].name === name) { tier = cachedTiers[i]; break; } }
        if (!serverUnlock.ids[tier.id]) lost.push(item.key);
      });
      return lost;
    }
    // The checkout guard waits at most this long for its basket read and removals, then lets the
    // customer's checkout go ahead: a request that never answers must not block checkout.
    var GUARD_WAIT = 10000;
    var isLoggedIn = customerId !== null;
    var cachedTiers = null;
    var lastCartTotal = null;
    var isEligible = false;
    var statusEligible = false; // from the status answer only (D27); isEligible also tracks the basket
    var isVip = false;
    var isLapsed = false;
    var customerOrderNumber = null;
    var hasGiftInCart = false;
    var hasGiftDiscount = false;
    var hasVipDiscount = false;
    var currentGiftTierName = null;

    // Multi-currency support — resolved after first cart fetch
    var currencyRate = 1;
    var currencyCode = 'GBP';
    var currencySymbol = '£';
    var currencyResolved = false;

    function resolveCurrency(cart) {
      if (currencyResolved) return;
      var cartCurrency = cart.currency || 'GBP';
      if (cartCurrency === 'GBP') { currencyResolved = true; return; }

      currencyCode = cartCurrency;
      currencySymbol = cartCurrency === 'EUR' ? '€' : cartCurrency === 'USD' ? '$' : cartCurrency + ' ';

      // Get rate: cart total in presentment currency / total in base currency
      // cart.total_price is in presentment, cart.original_total_price is also presentment
      // Use Shopify.currency.rate if the active currency matches the cart currency
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === cartCurrency) {
        currencyRate = parseFloat(window.Shopify.currency.rate) || 1;
      } else {
        // Fallback: estimate rate from cart item prices vs their GBP price
        // This isn't ideal but prevents showing wrong currency
        currencyRate = 1;
        currencyCode = 'GBP';
        currencySymbol = '£';
      }
      currencyResolved = true;
    }

    function convertThreshold(gbpAmount) {
      if (currencyRate === 1) return gbpAmount;
      var converted = gbpAmount * currencyRate;
      return Math.ceil(converted / 5 - 1e-9) * 5;
    }

    function formatPrice(amount) {
      return currencySymbol + amount.toFixed(0);
    }
    var instances = []; // Track all injected progress bar instances

    function statusCacheTtl(status) { return status === 'none' ? 60 * 1000 : 10 * 60 * 1000; }

    function init() {
      if (isLoggedIn) {
        // Check sessionStorage cache first (10 min TTL; 1 min for 'none')
        var cacheKey = 'pp_status_' + customerId;
        var cached = sessionStorage.getItem(cacheKey);
        if (cached) {
          try {
            var statusData = JSON.parse(cached);
            if (Date.now() - statusData.timestamp < statusCacheTtl(statusData.status)) {
              if (statusData.orderNumber) customerOrderNumber = statusData.orderNumber;
              if (statusData.status === 'eligible') { isEligible = true; statusEligible = true; fetchTiersAndStart(); }
              else if (statusData.status === 'vip') { isVip = true; injectAll(); checkCartAndRender(); }
              else if (statusData.status === 'lapsed') { isLapsed = true; injectAll(); updateAllInstances(); }
              if (!isEligible) startBasketWatch(); // P4-12: the basket is still kept safe
              return;
            }
          } catch(e) {}
        }

        // Cache miss — fetch from API
        fetchStatus(cacheKey, 0);
      } else {
        // Guests always see the progress bar
        fetchTiersAndStart();
      }
    }

    function fetchStatus(cacheKey, attempt) {
      fetch(PP_PROXY + '?action=status&customer_id=' + customerId)
        .then(function(r) {
          if (!r.ok) throw new Error('status HTTP ' + r.status);
          return r.json();
        })
        .then(function(data) {
          // Programme paused server-side. Return WITHOUT writing to
          // sessionStorage: persisting 'none' here would keep the progress
          // bar hidden for up to 10 minutes per tab after the kill switch is
          // flipped back on, and sessionStorage survives reloads (it only
          // clears when the tab closes), so the customer could not shake it
          // off by refreshing.
          if (data && data.disabled) return;
          // An error payload is not an answer: never cache it as 'none'.
          if (!data || data.error) throw new Error('status: ' + ((data && data.error) || 'empty'));
          var status = 'none';
          if (data.orderNumber) customerOrderNumber = data.orderNumber;
          if (data.vip) {
            isVip = true; status = 'vip';
            injectAll(); checkCartAndRender();
          } else if (data.lapsed) {
            isLapsed = true; status = 'lapsed';
            injectAll(); updateAllInstances();
          } else if (data.eligible) {
            isEligible = true; statusEligible = true; status = 'eligible';
            fetchTiersAndStart();
          }
          if (!isEligible) startBasketWatch(); // P4-12: the basket is still kept safe
          // Save to session storage
          sessionStorage.setItem(cacheKey, JSON.stringify({
            status: status,
            orderNumber: data.orderNumber || null,
            timestamp: Date.now()
          }));
        })
        .catch(function() {
          if (attempt < 1) setTimeout(function() { fetchStatus(cacheKey, attempt + 1); }, 3000);
        });
    }

    function checkCartAndRender() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          resolveCurrency(cart);
          hasVipDiscount = cart.discount_codes && cart.discount_codes.some(function(dc) {
            return dc.code && dc.code.toUpperCase() === 'PROPPRO';
          });
          updateAllInstances();
        })
        .catch(function() { updateAllInstances(); });
    }

    function fetchTiersAndStart() {
      // Read /cart.js FIRST so the initial tiers fetch can include
      // basket_skus. Without this, the first render under
      // basket-sku-prefix strategy with PF- items in cart would briefly
      // show GB gifts before the cart:updated re-fetch corrects it.
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          resolveCurrency(cart);
          var skuKey = basketSkuKeyFromCart(cart);
          window.__pp_currentBasketSkus = skuKey;
          window.__pp_lastCart = cart;
          window.__pp_currentCartKey = cartQtyKey(cart);
          lastBasketSkuKey = skuKey; // suppress the trailing re-fetch from updateFromCart
          return loadTiers(cart);
        })
        .then(function(data) {
          // No tiers and not switched off (P4-12): nothing to draw, but the basket is still kept safe.
          if (!data.tiers || data.tiers.length === 0) { if (!data.disabled) startBasketWatch(); return; }
          cachedTiers = data.tiers;
          basketWatch = false; // the bar proper runs from here (a status retry can get here after a watch started)
          setMarketplace(data.marketplaceProductIds);
          applyServerUnlock(data, window.__pp_currentCartKey);
          // An answer whose basket moved mid-request (P4-24) is asked for again on the next read.
          lastBasketSkuKey = data._ppUnverified ? null : refreshKeyFor(lastBasketSkuKey || '', window.__pp_currentCartKey || '');
          injectAll();
          updateFromCart();
        })
        .catch(function() { startBasketWatch(); });
    }

    function createInstance() {
      var template = document.getElementById('pp-progress-template');
      if (!template) return null;
      var clone = template.content.cloneNode(true);
      return clone.querySelector('.pp-progress-wrap');
    }

    function injectAll() {
      // Inject into cart page
      injectIntoCartPage();
      // Inject into drawer if it exists
      injectIntoDrawer();
    }

    function injectIntoCartPage() {
      if (window.location.pathname.indexOf('/cart') === -1) return;
      if (document.querySelector('.pp-progress-wrap[data-pp-context="page"]')) return;

      var el = createInstance();
      if (!el) return;
      el.setAttribute('data-pp-context', 'page');

      var shippingBar = document.querySelector('main .free-shipping-bar, main [class*="free-shipping"], main [class*="shipping-bar"]');
      var cartForm = document.querySelector('main form[action="/cart"]');
      var cartTable = document.querySelector('main .cart-items, main .cart__items, main table');

      if (shippingBar && shippingBar.parentNode) {
        shippingBar.parentNode.insertBefore(el, shippingBar.nextSibling);
      } else if (cartForm) {
        cartForm.insertBefore(el, cartForm.firstChild);
      } else if (cartTable && cartTable.parentNode) {
        cartTable.parentNode.insertBefore(el, cartTable);
      } else {
        return; // Nowhere to inject
      }
      instances.push(el);
    }

    function injectIntoDrawer() {
      var drawer = document.querySelector('cart-drawer, .js-cart-drawer');
      if (!drawer) return;
      if (drawer.querySelector('.pp-progress-wrap[data-pp-context="drawer"]')) return;

      var el = createInstance();
      if (!el) return;
      el.setAttribute('data-pp-context', 'drawer');

      // Inject above the subtotal in the drawer footer
      var subtotal = drawer.querySelector('.subtotal');
      if (subtotal && subtotal.parentNode) {
        subtotal.parentNode.insertBefore(el, subtotal);
      } else {
        var footer = drawer.querySelector('.cart-drawer__footer [data-merge="footer"]');
        if (footer) {
          footer.insertBefore(el, footer.firstChild);
        }
      }
      instances.push(el);
    }

    // Track the last basket SKU set so we only re-fetch tiers when the
    // basket SKU composition actually changes (NOT on every cart event).
    var lastBasketSkuKey = null;
    var tiersRefreshInFlight = false;
    var tiersRefreshDebounceTimer = null;

    function basketSkuKeyFromCart(cart) {
      if (!cart || !cart.items) return '';
      var out = [];
      var seen = {};
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var props = item.properties || {};
        var isGift = false;
        for (var k in props) {
          if (Object.prototype.hasOwnProperty.call(props, k) &&
              k.toLowerCase() === 'free gift' && props[k]) {
            isGift = true;
            break;
          }
        }
        if (isGift) continue;
        var sku = String(item.variant_id || '');
        if (!sku || seen[sku]) continue;
        seen[sku] = 1;
        out.push(sku);
      }
      out.sort();
      return out.join(',');
    }

    // CRITICAL VITALS SAFETY: this is only invoked from updateFromCart,
    // which itself is only triggered by page-load-installed listeners
    // (cart:updated, the wrapped fetch/XHR shim below, the cart-drawer
    // events, and the page-load initial call). It is NEVER called from
    // a click handler. The trailing-edge retry uses setTimeout from
    // *within* the in-flight fetch's .then(), which is safe because
    // that .then() is itself rooted in the leading-edge call that came
    // from a page-load-installed listener.
    function maybeRefreshTiersForBasket(skuKey) {
      if (tiersRefreshInFlight) return;
      tiersRefreshInFlight = true;
      // Leading-edge debounce (750ms): a chatty cart drawer that fires
      // 5 events in 200ms collapses into one fetch.
      if (tiersRefreshDebounceTimer) clearTimeout(tiersRefreshDebounceTimer);
      tiersRefreshDebounceTimer = setTimeout(function() {
        var cartKeyAtRequest = window.__pp_currentCartKey || '';
        loadTiers(window.__pp_lastCart)
          .then(function(data) {
            if (data && data.tiers && data.tiers.length) {
              cachedTiers = data.tiers;
              setMarketplace(data.marketplaceProductIds);
              applyServerUnlock(data, cartKeyAtRequest);
            }
            if (typeof window.__pp_applyFreshTiers === 'function') {
              window.__pp_applyFreshTiers(data);
            }
            tiersRefreshInFlight = false;
            // Trailing-edge: if the basket changed AGAIN while this
            // fetch was in flight, fire one more refresh with the
            // current key.
            // P4-24: the basket moved while it was being judged. Ask again for the basket as it is
            // now, at most UNVERIFIED_RETRIES times in a row; after that the next change asks.
            if (data && data._ppUnverified && unverifiedRetries < UNVERIFIED_RETRIES) {
              unverifiedRetries++;
              lastBasketSkuKey = null;
              lastCartTotal = null;
              updateFromCart();
              return;
            }
            if (!(data && data._ppUnverified)) unverifiedRetries = 0;
            var nowKey = currentRefreshKey();
            if (nowKey !== skuKey) {
              maybeRefreshTiersForBasket(nowKey);
            } else if (serverDecides && window.__pp_lastCart) {
              lastCartTotal = null;
              evaluateCart(window.__pp_lastCart);
            }
          })
          .catch(function() {
            // On error, restore lastBasketSkuKey so the next cart event
            // will retry — avoid getting permanently stuck on a stale key.
            lastBasketSkuKey = null;
            tiersRefreshInFlight = false;
          });
      }, 750);
    }

    function updateFromCart() {
      readCart()
        .then(evaluateCart)
        .catch(function() {});
    }

    function evaluateCart(cart) {
          resolveCurrency(cart);
          currentGiftTierName = null;
          hasGiftInCart = false;

          // Track the basket SKU set for the region-detection resolver.
          // If it changed since the last cart event, re-fetch the tiers
          // catalogue so the modal can show the correct region's gifts.
          var skuKey = basketSkuKeyFromCart(cart);
          window.__pp_currentBasketSkus = skuKey;
          window.__pp_lastCart = cart;
          window.__pp_currentCartKey = cartQtyKey(cart);
          var refreshKey = refreshKeyFor(skuKey, window.__pp_currentCartKey);
          if (!basketWatch && refreshKey !== lastBasketSkuKey) {
            lastBasketSkuKey = refreshKey;
            maybeRefreshTiersForBasket(refreshKey);
          }

          // Calculate cart total, only excluding the value of 1 unit per gift line item
          var cartTotal = 0;
          var ownLines = 0;
          cart.items.forEach(function(item) {
            var isGift = item.properties && item.properties['Free Gift'];
            if (marketplaceIds[item.product_id]) {
              if (isGift) { hasGiftInCart = true; currentGiftTierName = item.properties['Free Gift']; }
              return;
            }
            // Use price (per unit in cents) and quantity
            var unitPrice = item.price || item.original_price || 0;
            if (isGift) {
              hasGiftInCart = true;
              currentGiftTierName = item.properties['Free Gift'];
              // Include value of extra units (qty - 1) in cart total
              if (item.quantity > 1) {
                cartTotal += (unitPrice * (item.quantity - 1)) / 100;
              }
            } else {
              cartTotal += (unitPrice * item.quantity) / 100;
              if (unitPrice > 0 && item.quantity > 0) ownLines++;
            }
          });
          if (ownLines === 0) cartTotal = 0;
          window.__pp_ownLineCount = ownLines;
          // Mirror of hasApplicableGiftDiscount() in app/lib/gift-logic.ts —
          // unit-tested there. Keep both in sync. applicable:true is required:
          // Shopify lists deleted/expired codes as applicable:false; treating
          // those as "active" suppresses auto-removal + checkout intercept.
          hasGiftDiscount = cart.discount_codes && cart.discount_codes.some(function(dc) {
            return dc.code && isGiftCode(dc.code) && dc.applicable === true;
          });
          hasVipDiscount = cart.discount_codes && cart.discount_codes.some(function(dc) {
            return dc.code && dc.code.toUpperCase() === 'PROPPRO';
          });

          // If gift is in cart, check if cart still qualifies for the gift's tier
          if (hasGiftInCart && cachedTiers) {
            // Find the gift's tier
            var giftTier = cachedTiers[0]; // default to lowest
            if (currentGiftTierName) {
              for (var ti = 0; ti < cachedTiers.length; ti++) {
                if (cachedTiers[ti].name === currentGiftTierName) {
                  giftTier = cachedTiers[ti];
                  break;
                }
              }
            }
            var giftTierLost = serverVerdictFresh() && !serverUnlock.ids[giftTier.id];
            if (giftTierLost && !claimInFlight()) {
              // Cart no longer qualifies — remove gift item and discount
              var giftItem = cart.items.find(function(item) {
                return item.properties && item.properties['Free Gift'];
              });

              if (giftItem && removalAllowed([giftItem.key])) {
                // Remove the gift line item then redirect to clear the discount
                try { sessionStorage.removeItem('pp_discount_code'); } catch (e) {}
                // In the removal queue (P5-12): a line already taken out (by the checkout guard,
                // say) is left alone, with nothing put back and no redirect.
                var lostKey = giftItem.key;
                tierLostRemovals++;
                serialRemoval(cart, function(c) {
                  var line = linesWithKeys(c, [lostKey])[0];
                  if (!line) return false;
                  return sendRemoval([line], function() {
                    return fetch('/cart/change.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ id: lostKey, quantity: 0 })
                    });
                  }, function(r) {
                    if (!r.ok) { removalFailed([lostKey]); return false; }
                    return true;
                  }).catch(function() { removalFailed([lostKey]); return false; });
                }).then(function(removed) {
                  tierLostRemovals--;
                  if (removed) tierLostRemoved = true;
                  // Redirect to clear discount and return to cart, the gift line's paid units
                  // put back first (P5-12)
                  if (removed) window.location.href = '/discount/clear?redirect=/cart';
                }, function() { tierLostRemovals--; });
                return;
              }
            }
          }

          strayGiftKeys = strayGiftLines(cart);
          if (strayGiftKeys.length && !autoRemoveInFlight && removalAllowed(strayGiftKeys)) {
            autoRemoveInFlight = true;
            var strayKeys = strayGiftKeys;
            removeGiftLines(strayKeys, cart).then(function() {
              autoRemoveInFlight = false;
              lastCartTotal = null;
              updateFromCart();
            }, function() { autoRemoveInFlight = false; removalFailed(strayKeys); });
          }
          // P4-9: back on the basket after the checkout guard re-applied a code. Carry on to
          // checkout once every gift line is discounted; stop waiting once there is nothing to
          // wait for (the grace is over, or no gift line lacks its discount).
          if (resumePending()) {
            var cover = giftCover(cart);
            if (cover.covered && !cover.uncovered.length) { endResume(); window.location.href = '/checkout'; return; }
            if (!(cover.uncovered.length && giftGrace())) endResume();
          }
          // P4-12: a gift line with no gift code applied is taken out on every basket read, bar
          // or no bar (the bar's own message about it still shows where the bar is drawn).
          if (hasGiftInCart && !hasGiftDiscount) {
            if (giftGrace()) scheduleGraceRetry();
            else removeCodelessGift();
          }

          // Toggle body class to hide Vitals upsell when gift is active
          if (hasGiftInCart) {
            document.body.classList.add('pp-has-gift');
          } else {
            document.body.classList.remove('pp-has-gift');
          }
          if (cartTotal !== lastCartTotal || hasGiftInCart) {
            lastCartTotal = cartTotal;

            var qualifiesForTier = cachedTiers && cachedTiers.some(function(t) { return isTierUnlocked(t, cartTotal); });
            // Don't re-fetch eligibility — fetch is broken after page load (Vitals).
            // If they qualify for a tier and are logged in, assume eligible.
            // The page-load fetch already confirmed eligibility.
            isEligible = isLoggedIn && qualifiesForTier;
            if (!basketWatch || isVip || isLapsed) updateAllInstances();
          }
    }

    // Danny, 2 Oct: every "20% off" promise carries a * and a small terms link (the Prop Pro page).
    function ppTerms() { return '<span class="pp-terms">*<a href="/pages/proppro-rewardingloyalty" target="_blank" rel="noopener">Terms apply</a></span>'; }
    // Danny, 2 Oct: marketplace products (PropHouse etc.) never count towards gifts or Prop Pro, so
    // their pages show no PropPerks message at all. Tagged in the theme snippet, or in the server's
    // marketplace list once the tiers have loaded.
    function onMarketplaceProduct() {
      var prod = PP.product;
      if (!prod || prod.id === undefined || prod.id === null) return false;
      return prod.marketplace === true || !!marketplaceIds[prod.id];
    }
    function productMessageHtml() {
      if (onMarketplaceProduct()) return '';
      if (isVip) {
        var vip = 'You\'re a <strong>Prop Pro</strong> — 20% off all your orders.*';
        if (!hasVipDiscount) vip += ' <a class="pp-product-msg__link" href="/discount/PropPro?redirect=' + encodeURIComponent(window.location.pathname) + '">Apply 20% off</a>';
        return vip + ppTerms();
      }
      if (isLapsed) return 'Welcome back! This purchase reactivates your <strong>Prop Pro</strong> status, with 20% off your future orders.*' + ppTerms();
      if (!cachedTiers || !cachedTiers.length) return '';
      if (!isLoggedIn) {
        return '<a class="pp-product-msg__link" href="/customer_authentication/login?return_to=' + encodeURIComponent(window.location.pathname) + '">Log in</a> to earn a free gift on each of your first three orders.';
      }
      if (!statusEligible || !customerOrderNumber) return '';
      var msg = 'Your next order includes a free gift: spend ' + formatPrice(convertThreshold(cachedTiers[0].threshold)) + ' or more on our products to choose one in your basket.';
      if (customerOrderNumber === 3) msg += ' This order also makes you a <strong>Prop Pro</strong>, with 20% off all future orders.*' + ppTerms();
      return msg;
    }
    // Where the message goes (Danny, 2 Oct): between the quantity box and Add to cart, in the
    // product's own form — the one with an add button (the page's first cart form can be the
    // "pay in instalments" widget under the price). Falls back to just above that form.
    function productMessageSpot() {
      var forms = document.querySelectorAll('main form[action*="/cart/add"], form[action*="/cart/add"]');
      var form = null, submit = null;
      for (var i = 0; i < forms.length && !form; i++) {
        submit = forms[i].querySelector('button[name="add"], button[type="submit"], input[type="submit"]');
        if (submit) form = forms[i];
      }
      if (!form) return null;
      var qty = form.querySelector('input[name="quantity"]');
      if (qty) {
        var node = submit;
        while (node.parentNode && node.parentNode !== form && !node.parentNode.contains(qty)) node = node.parentNode;
        if (node.parentNode && node.parentNode.contains(qty)) return { parent: node.parentNode, before: node };
      }
      return { parent: form.parentNode, before: form };
    }
    function renderProductMessage() {
      if (window.location.pathname.indexOf('/products/') === -1) return;
      var spot = productMessageSpot();
      var el = document.querySelector('.pp-product-msg');
      var html = productMessageHtml();
      if (!html || !spot) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('div');
        el.className = 'pp-product-msg';
      }
      if (el.parentNode !== spot.parent || el.nextSibling !== spot.before) spot.parent.insertBefore(el, spot.before);
      if (el.innerHTML !== html) el.innerHTML = html;
    }

    function updateAllInstances() {
      // Re-inject in case drawer was opened after initial load
      injectIntoDrawer();
      renderProductMessage();

      instances.forEach(function(el) {
        if (!el || !el.parentNode) return;
        renderInstance(el);
      });

      updateCartGiftCard();

      // Share current cart total with modal script for tier unlock decisions
      if (lastCartTotal !== null) {
        window.__pp_currentCartTotal = lastCartTotal;
      }
    }

    function buildGiftCardHtml(unlockedTier) {
      var btnHtml;
      if (isLoggedIn && isEligible) {
        btnHtml = '<button type="button" class="pp-cart-gift__btn pp-open-modal">Choose Your Gift</button>';
      } else {
        btnHtml = '<a href="/customer_authentication/login?return_to=%2Fcart" class="pp-cart-gift__btn">Log In to Claim</a>';
      }

      return '<div class="pp-cart-gift__image">🎁</div>' +
        '<div class="pp-cart-gift__info">' +
          '<div class="pp-cart-gift__title">Your Free Gift</div>' +
          '<div class="pp-cart-gift__subtitle">You\'ve unlocked ' + esc(unlockedTier.name) + ' rewards!</div>' +
          btnHtml +
        '</div>' +
        '<div class="pp-cart-gift__price">' +
          '<div class="pp-cart-gift__price-free">FREE</div>' +
        '</div>';
    }

    function updateCartGiftCard() {
      var cartTotal = lastCartTotal || 0;
      var unlockedTier = null;
      if (cachedTiers) {
        for (var i = cachedTiers.length - 1; i >= 0; i--) {
          if (isTierUnlocked(cachedTiers[i], cartTotal)) { unlockedTier = cachedTiers[i]; break; }
        }
      }

      var shouldShow = unlockedTier && !hasGiftInCart && (!isLoggedIn || isEligible);

      // Cart page
      var existingPage = document.querySelector('.pp-cart-gift[data-pp-context="page"]');
      if (window.location.pathname.indexOf('/cart') !== -1) {
        if (!shouldShow) {
          if (existingPage) existingPage.remove();
        } else {
          if (!existingPage) {
            existingPage = document.createElement('div');
            existingPage.className = 'pp-cart-gift';
            existingPage.setAttribute('data-pp-context', 'page');
            var lastItem = document.querySelector('.cart-item:last-of-type');
            if (lastItem && lastItem.parentNode) {
              lastItem.parentNode.insertBefore(existingPage, lastItem.nextSibling);
            }
          }
          if (existingPage.parentNode) existingPage.innerHTML = buildGiftCardHtml(unlockedTier);
        }
      }

      // Cart drawer
      var drawer = document.querySelector('cart-drawer, .js-cart-drawer');
      if (drawer) {
        var existingDrawer = drawer.querySelector('.pp-cart-gift[data-pp-context="drawer"]');
        if (!shouldShow) {
          if (existingDrawer) existingDrawer.remove();
        } else {
          if (!existingDrawer) {
            existingDrawer = document.createElement('div');
            existingDrawer.className = 'pp-cart-gift';
            existingDrawer.setAttribute('data-pp-context', 'drawer');
            // Insert at end of the scrollable content area, after cart items
            var contentUpper = drawer.querySelector('.cart-drawer__content-upper');
            if (contentUpper) {
              contentUpper.appendChild(existingDrawer);
            }
          }
          if (existingDrawer.parentNode) existingDrawer.innerHTML = buildGiftCardHtml(unlockedTier);
        }
      }
    }

    function renderInstance(el) {
      var msgEl = el.querySelector('.pp-progress-msg');
      var trackEl = el.querySelector('.pp-progress-track');
      var fillEl = el.querySelector('.pp-progress-fill');
      var markersEl = el.querySelector('.pp-progress-markers');
      var labelsEl = el.querySelector('.pp-progress-labels');

      if (isVip) {
        trackEl.style.display = 'none';
        labelsEl.style.display = 'none';
        var previewElVip = el.querySelector('.pp-gift-preview');
        if (previewElVip) previewElVip.style.display = 'none';
        var vipMsg = '<span class="pp-green">You\'ve achieved Prop Pro status!</span> 20% off all your orders.*' + ppTerms();
        if (hasVipDiscount) {
          vipMsg += '<br><span class="pp-green">✅ 20% Prop Pro discount applied!</span>';
        } else {
          vipMsg += '<br><a class="pp-progress-choose" href="/discount/PropPro?redirect=' + encodeURIComponent(window.location.pathname) + '">Apply 20% Off</a>';
        }
        msgEl.innerHTML = vipMsg;
        el.classList.remove('pp-progress-hidden');
        return;
      }

      if (isLapsed) {
        trackEl.style.display = 'none';
        labelsEl.style.display = 'none';
        var previewElLapsed = el.querySelector('.pp-gift-preview');
        if (previewElLapsed) previewElLapsed.style.display = 'none';
        msgEl.innerHTML = 'Welcome back! This purchase qualifies you as a <strong>Prop Pro</strong> with 20% off all future orders*, provided you order within 60 days of your last.' + ppTerms();
        el.classList.remove('pp-progress-hidden');
        return;
      }

      if (!cachedTiers) return;

      trackEl.style.display = '';
      labelsEl.style.display = '';

      var cartTotal = lastCartTotal || 0;
      var maxDisplayThreshold = convertThreshold(cachedTiers[cachedTiers.length - 1].threshold);
      var progressPercent = Math.min((cartTotal / maxDisplayThreshold) * 100, 100);
      fillEl.style.width = progressPercent + '%';

      markersEl.innerHTML = '';
      labelsEl.innerHTML = '';
      var previewEl = el.querySelector('.pp-gift-preview');
      previewEl.innerHTML = '';
      previewEl.classList.remove('pp-visible');
      var unlockedTier = null;
      var nextTier = null;

      // Add zero start label
      var zeroLabel = document.createElement('div');
      zeroLabel.className = 'pp-progress-label';
      zeroLabel.style.left = '0%';
      zeroLabel.style.transform = 'none';
      zeroLabel.style.border = 'none';
      zeroLabel.style.padding = '3px 0';
      zeroLabel.style.cursor = 'default';
      zeroLabel.style.background = 'none';
      zeroLabel.textContent = formatPrice(0);
      labelsEl.appendChild(zeroLabel);

      for (var i = 0; i < cachedTiers.length; i++) {
        var tier = cachedTiers[i];
        var displayThreshold = convertThreshold(tier.threshold);
        var unlocked = isTierUnlocked(tier, cartTotal);
        if (unlocked) unlockedTier = tier;
        if (!unlocked && !nextTier) nextTier = tier;

        var pos = (displayThreshold / maxDisplayThreshold) * 100;

        var marker = document.createElement('div');
        marker.className = 'pp-progress-marker' + (unlocked ? ' pp-reached' : '');
        marker.style.left = pos + '%';
        markersEl.appendChild(marker);

        var label = document.createElement('div');
        label.className = 'pp-progress-label' + (unlocked ? ' pp-reached' : '');
        label.style.left = pos + '%';
        label.textContent = formatPrice(displayThreshold);
        label.setAttribute('data-tier-index', i);

        (function(t, lbl) {
          lbl.addEventListener('click', function() {
            var allLabels = labelsEl.querySelectorAll('.pp-progress-label');
            var wasActive = lbl.classList.contains('pp-active');

            allLabels.forEach(function(l) { l.classList.remove('pp-active'); });
            previewEl.innerHTML = '';
            previewEl.classList.remove('pp-visible');

            if (!wasActive && t.gifts && t.gifts.length > 0) {
              lbl.classList.add('pp-active');
              previewEl.innerHTML = t.gifts.map(function(g) { return esc(g.title); }).join(' &middot; ');
              previewEl.classList.add('pp-visible');
            }
          });
        })(tier, label);

        labelsEl.appendChild(label);
      }

      // Check if customer qualifies for a higher tier than their current gift
      var canUpgrade = false;
      if (hasGiftInCart && currentGiftTierName && unlockedTier) {
        canUpgrade = currentGiftTierName !== unlockedTier.name;
      }

      var msg = '';
      if (hasGiftInCart && hasGiftDiscount && canUpgrade) {
        msg = '🎉 You now qualify for a <strong>' + esc(unlockedTier.name) + '</strong> gift! <button type="button" class="pp-progress-choose pp-open-modal">Upgrade your gift →</button>';
      } else if (hasGiftInCart && hasGiftDiscount) {
        msg = '<span class="pp-green">✅ Free gift added!</span>';
        if (nextTier) {
          var remaining = remainingToUnlock(nextTier, cartTotal);
          msg += ' Spend <strong>' + formatPrice(parseFloat(remaining)) + '</strong> more to upgrade to <strong>' + esc(nextTier.name) + '</strong>!';
        }
      } else if (hasGiftInCart && !hasGiftDiscount) {
        // Gift in cart but no discount — code expired or was replaced.
        // Grace period: after /discount/CODE redirect, Shopify may take a moment
        // to propagate the code to /cart.js. Don't auto-remove during this window.
        // PropPerks: never remove the gift while a claim is in flight (in any tab). Flags are
        // read, not consumed, so a second bar instance (cart page + drawer) can't use them up.
        if (giftGrace()) {
          // Still within grace period — retry shortly instead of removing
          scheduleGraceRetry();
          msg = '<span class="pp-green">Applying your free gift discount...</span>';
        } else {
          // Grace expired or no redirect — genuinely missing discount, auto-remove
          // (PropPerks: removeCodelessGift — single-flight, marker re-checked, bounded.)
          removeCodelessGift();
          msg = '⚠️ Your free gift discount expired. <button type="button" class="pp-progress-choose pp-open-modal">Choose a new gift</button>';
        }
      } else if (!unlockedTier && nextTier) {
        var remaining = remainingToUnlock(nextTier, cartTotal);
        msg = 'Spend <strong>' + formatPrice(parseFloat(remaining)) + '</strong> more to unlock a <span class="pp-green">free gift</span>!';
      } else if (unlockedTier) {
        msg = '<span class="pp-green">✅ Free gift unlocked!</span>';
      }

      if (!hasGiftInCart && unlockedTier && isLoggedIn && isEligible) {
        msg += '<br><button type="button" class="pp-progress-choose pp-open-modal">Add Free Gift</button>';
      } else if (!hasGiftInCart && unlockedTier && !isLoggedIn) {
        msg += '<br><a class="pp-progress-choose" href="/customer_authentication/login?return_to=%2Fcart">Log In to Claim Free Gift</a>';
      } else if (!hasGiftInCart && !unlockedTier && !isLoggedIn && nextTier) {
        msg += '<br><a class="pp-progress-login-link" href="/customer_authentication/login?return_to=%2Fcart">Log in to claim free gifts →</a>';
      }

      // Prop Pro teaser for customers on their 3rd order (last milestone)
      if (customerOrderNumber === 3 && isLoggedIn) {
        msg += '<br><span style="font-size:12px;color:#666">This is your last free gift order. After this you\'ll achieve <strong>Prop Pro</strong> status with 20% off all future orders!*</span>' + ppTerms();
      }

      msgEl.innerHTML = msg;
      el.classList.remove('pp-progress-hidden');
    }

    // Event-driven cart updates (no polling)
    function triggerCartUpdate() {
      if (cachedTiers || isVip || isLapsed || basketWatch) {
        lastCartTotal = null;
        updateFromCart();
      }
    }
    window.__pp_refreshBasket = triggerCartUpdate;

    // Shopify AJAX cart events
    document.addEventListener('cart:updated', triggerCartUpdate);

    // Delegated click handler for "open modal" buttons
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.pp-open-modal');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        if (window.__pp_reopenGiftModal && window.__pp_reopenGiftModal()) return;
        // No cached data — reload as last resort
        sessionStorage.removeItem('pp_skipped');
        if (customerId) sessionStorage.removeItem('pp_status_' + customerId);
        window.location.reload();
      }
    });

    // Symmetry theme events
    document.addEventListener('on:cart-drawer:after-open', function() {
      injectIntoDrawer();
      triggerCartUpdate();
    });
    document.addEventListener('on:cart:after-merge', triggerCartUpdate);

    // Intercept fetch calls to cart API endpoints
    var originalFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      var result = originalFetch.apply(this, arguments);
      if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1)) {
        result.then(function() {
          setTimeout(triggerCartUpdate, 500);
        });
      }
      return result;
    };

    // Intercept XMLHttpRequest for older themes/apps
    var originalXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
        var xhr = this;
        xhr.addEventListener('load', function() {
          setTimeout(triggerCartUpdate, 500);
        });
      }
      return originalXHROpen.apply(this, arguments);
    };

    // Checkout intercept: prevent checkout with gift at full price.
    // Uses cached hasGiftInCart / hasGiftDiscount (updated by updateFromCart),
    // so no fetch needed in the handler — Vitals-safe.
    function hookCheckout() {
      // Checkout button(s) and form(s)
      var checkoutBtns = document.querySelectorAll('[name="checkout"], button[type="submit"][value="checkout"], a[href="/checkout"], a[href*="checkout"], #checkout-btn, .cart__checkout-button, #CartDrawer-Checkout, .shopify-payment-button button');
      var cartForms = document.querySelectorAll('form[action="/cart"], form[action="/checkout"]');

      // Whenever the last basket read showed a gift line (or this page took one out), checkout
      // waits for a fresh /cart.js read and judges that:
      //   • a leftover (an undiscounted gift line beside a discounted one) is taken out;
      //   • every gift line discounted by an applied gift code: checkout goes ahead as the
      //     customer asked (the form or link is re-triggered, so notes and quantities post);
      //   • no gift line discounted: the stored code is re-applied via the basket, where the bar
      //     carries on to checkout only if it then discounts the gift (once per code, see
      //     startReapply); otherwise, or the next time, the undiscounted gift lines are taken out;
      //   • a gift whose tier the server's verdict for this basket says is lost (the bar's own
      //     removal was refused) is taken out; if that fails too, the discount is cleared on the
      //     way to checkout, so the gift is never free below its tier. When the lost gift is one
      //     its code discounts, the discount is cleared even when the removal worked: the gift
      //     line's paid units are then back as an ordinary line of the same variant (P5-12),
      //     which the gift code, still applicable, would make free (pass-6 P6-2); likewise when
      //     paid units go back and no gift line is discounted but a gift code is on the basket
      //     (displaced, or not yet applied: it may apply at checkout). The bar's own
      //     tier-lost removal clears it too, and while one is under way (or once one was made)
      //     every way on clears it (tierLostLeaving), whatever the basket read showed.
      // Checkout is never blocked: if the basket can't be read, or a removal fails, it goes ahead,
      // and after GUARD_WAIT it goes ahead whatever is still unanswered.
      // Once this page has taken a line out (or may have: formStale), the theme's basket form is
      // stale (its quantity boxes go by position), so checkout is then reached directly, never by
      // posting that form (pass-6 P6-1).
      // What the customer pressed, to re-trigger once the basket is judged: the basket form (with
      // the button that submitted it), or a checkout button in a form, or a checkout link.
      // Anything else, or a browser that can't re-trigger it (no requestSubmit), goes straight to
      // /checkout (carryOn's catch).
      // One press at a time (pass-5 P5-11). Each press used to be judged on its own, so in a
      // double-click the second press (its re-apply refused, as the first had just done it) took
      // the gift out and sent the customer to checkout over the first press's re-apply. Now a
      // press while another is being judged, or once one has sent the customer on (to checkout,
      // or to re-apply the code), is held and does nothing. The hold ends when a press ends by
      // re-triggering the customer's own checkout (which may not leave the page: a payment
      // window, say), when the page comes back from the browser's back-forward cache, or
      // GUARD_HOLD after the press began or last sent the customer on, should the page somehow
      // still be here.
      var GUARD_HOLD = 30000;
      var guardHeldAt = 0; // 0: not held (its age is then decades)
      function guardHeld() {
        var age = Date.now() - guardHeldAt;
        return age >= 0 && age < GUARD_HOLD;
      }
      window.addEventListener('pageshow', function(ev) { if (ev.persisted) guardHeldAt = 0; });
      function checkoutOrigin(e) {
        var el = e.currentTarget || {};
        if (e.type === 'submit') return { form: el, submitter: e.submitter };
        return el.form || el.tagName === 'A' ? { el: el } : null;
      }
      function interceptCheckout(e) {
        if (guardBypass) return;
        if (guardHeld()) { e.preventDefault(); e.stopPropagation(); return; } // another press is under way
        if (!hasGiftInCart && !formStale) return; // no gift line in the last basket read: let checkout proceed
        e.preventDefault();
        e.stopPropagation();
        guardHeldAt = Date.now();
        var origin = checkoutOrigin(e);
        // Exactly one way out per press: whichever comes first of the judgement and GUARD_WAIT.
        var done = false;
        var go = function(url) { guardHeldAt = Date.now(); window.location.href = url; };
        var settle = function(fn) { return function() { if (done) return; done = true; fn(); }; };
        var clearToCheckout = settle(function() { go('/discount/clear?redirect=/checkout'); });
        var toCheckout = settle(function() { go(tierLostLeaving() ? '/discount/clear?redirect=/checkout' : '/checkout'); });
        var carryOn = settle(function() {
          if (tierLostLeaving()) { go('/discount/clear?redirect=/checkout'); return; }
          if (formStale) { go('/checkout'); return; }
          guardBypass = true;
          try {
            if (origin.form) origin.form.requestSubmit(origin.submitter);
            else origin.el.click();
            guardHeldAt = 0; // the customer's own checkout, re-triggered: a later press is judged afresh
          } catch (err) {
            go('/checkout'); // nothing to re-trigger (origin null), or it can't be
          } finally {
            guardBypass = false;
          }
        });
        setTimeout(carryOn, GUARD_WAIT);
        // (An error answer has no items: no gift line in it, so checkout goes ahead as asked.)
        readCart()
          .then(function(cart) {
            if (done) return; // GUARD_WAIT has already let checkout go ahead
            var stray = strayGiftLines(cart);
            var lost = tierLostGiftLines(cart);
            if (lost.length) {
              // A lost gift its code discounts: once it is out, its paid units (put back) would be
              // free under that code, so the discount is cleared whether the removal worked or
              // not (P6-2). A lost leftover the code doesn't discount is only taken out: its paid
              // units cost what they should, and clearing would charge for a gift still valid.
              // With no gift line discounted at all, a gift code still on the basket isn't
              // applying just now (displaced by another discount, or not yet applied) but may apply
              // at checkout, to the paid units put back: the discount is cleared whenever any are.
              var lostCover = giftCover(cart);
              var lostCovered = lost.some(function(k) { return lostCover.uncovered.indexOf(k) === -1; })
                || (!lostCover.covered && linesWithKeys(cart, lost).some(function(item) { return item.quantity > 1; })
                  && (cart.discount_codes || []).some(function(dc) { return isGiftCode(dc.code); }));
              return removeGiftLines(lost.concat(stray.filter(function(k) { return lost.indexOf(k) === -1; })), cart).then(lostCovered ? clearToCheckout : toCheckout, clearToCheckout);
            }
            if (stray.length) return removeGiftLines(stray, cart).then(toCheckout, toCheckout);
            var cover = giftCover(cart);
            if (cover.covered || !cover.uncovered.length) { carryOn(); return; }
            var code = storedGiftCode();
            if (code && cover.live[code.toUpperCase()] !== 1 && startReapply(code)) {
              done = true;
              go('/discount/clear?redirect=' + encodeURIComponent('/discount/' + encodeURIComponent(code) + '?redirect=/cart'));
              return;
            }
            return removeGiftLines(cover.uncovered, cart).then(toCheckout, toCheckout);
          })
          .catch(carryOn);
      }

      checkoutBtns.forEach(function(btn) {
        btn.addEventListener('click', interceptCheckout, true);
      });
      cartForms.forEach(function(form) {
        form.addEventListener('submit', interceptCheckout, true);
      });
    }

    // Hook after DOM is ready (checkout buttons exist)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hookCheckout);
    } else {
      hookCheckout();
    }

    // Start
    init();
  })();
